import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AppLayout, PageHeader } from "@/components/Layout";
import { Gavel } from "lucide-react";

export default function Judges() {
  const [judges, setJudges] = useState([]);
  useEffect(() => {
    api.get("/judges").then((r) => setJudges(r.data)).catch(() => {});
  }, []);

  return (
    <AppLayout>
      <PageHeader subtitle="The Panel" title="Meet the Judges" />
      <div className="space-y-3 px-4 pt-2">
        {judges.length === 0 && <p className="text-sm text-muted-foreground">Judge information coming soon.</p>}
        {judges.map((j, i) => (
          <div key={j.id} data-testid={`judge-${j.id}`}
            className="flex items-start gap-4 rounded-xl border border-border bg-card p-4 shadow-sm animate-fade-up"
            style={{ animationDelay: `${i * 40}ms` }}>
            <div className="h-16 w-16 shrink-0 overflow-hidden rounded-full bg-muted">
              {j.photo ? (
                <img src={j.photo} alt={j.name} className="h-full w-full object-cover" />
              ) : (
                <div className="grid h-full w-full place-items-center bg-primary/10 text-primary">
                  <Gavel size={22} />
                </div>
              )}
            </div>
            <div className="flex-1">
              <h3 className="font-display text-xl font-bold text-primary">{j.name}</h3>
              <p className="text-xs font-bold uppercase tracking-wider text-secondary">{j.role || "Judge"}</p>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground/80">{j.bio}</p>
            </div>
          </div>
        ))}
      </div>
    </AppLayout>
  );
}
